import React from 'react';

export default function HealthCheck() {

    return (
        <h3> Hey there !! The app is running</h3>
    )
}